var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "container cards-filter-buttons" }, [
      _c(
        "div",
        { staticClass: "-mx-4 flex flex-wrap items-end justify-between" },
        [
          _c("div", { staticClass: "sm:hidden px-4 w-full mb-4" }, [
            _c(
              "div",
              {
                staticClass:
                  "filter-button dpd-filter_toggle w-full mb-4 sm:mb-0",
                class: { active: this.filtersTrayOpened },
                on: {
                  click: function($event) {
                    return _vm.toggleFiltersTray()
                  }
                }
              },
              [_vm._v("Alle categorieën")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "sm:absolute dpd-filter_tray",
                class: { hidden: !this.filtersTrayOpened }
              },
              _vm._l(this.postTypes, function(postType, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass:
                      "px-6 sm:px-4 sm:whitespace-no-wrap flex items-start mb-2 md:mb-0"
                  },
                  [
                    _c("input", {
                      attrs: {
                        type: "radio",
                        name: "catfilter" + index,
                        id: "catfilter" + index
                      },
                      domProps: {
                        checked: _vm.checkIfSelected(
                          "post_type",
                          postType.value
                        ),
                        value: postType.value
                      },
                      on: {
                        click: function($event) {
                          return _vm.selectFilter(
                            "post_type",
                            postType.value,
                            true
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "catfilter" + index } }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        class: {
                          active: _vm.checkIfSelected(
                            "post_type",
                            postType.value
                          )
                        },
                        attrs: { for: "catfilter" + index }
                      },
                      [_vm._v(_vm._s(postType.label))]
                    )
                  ]
                )
              }),
              0
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "hidden sm:block px-4 w-full md:w-1/2 mb-8 md:mb-0"
            },
            [
              _c(
                "button",
                {
                  class: [
                    "filter-button cursor-pointer",
                    { selectedfilter: _vm.formData.post_type.length === 0 }
                  ],
                  on: {
                    click: function($event) {
                      return _vm.selectFilter("post_type", "all", true)
                    }
                  }
                },
                [_vm._v("Alles")]
              ),
              _vm._v(" "),
              _vm._l(this.postTypes, function(postType, index) {
                return _c(
                  "button",
                  {
                    key: index,
                    class: [
                      "filter-button cursor-pointer",
                      {
                        selectedfilter: _vm.checkIfSelected(
                          "post_type",
                          postType.value
                        )
                      }
                    ],
                    on: {
                      click: function($event) {
                        return _vm.selectFilter(
                          "post_type",
                          postType.value,
                          true
                        )
                      }
                    }
                  },
                  [_vm._v(_vm._s(postType.label))]
                )
              })
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "px-4 w-full md:w-1/2" }, [
            _c("div", { staticClass: "flex flex-wrap sm:justify-end" }, [
              _c(
                "div",
                {
                  staticClass:
                    "relative dpd-filter w-full sm:w-auto mb-4 sm:mb-0"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "filter-button dpd-filter_toggle dpd-filter_toggle-deelnemer w-full mb-4 sm:mb-0",
                      class: {
                        active: this.deelnemerTrayOpened,
                        "text-blue": this.formData["deelnemers"].length > 0
                      },
                      on: {
                        click: function($event) {
                          return _vm.toggleDeelnemerTray()
                        }
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          this.formData["deelnemers"].length > 0
                            ? "Vrienden (" +
                                this.formData["deelnemers"].length +
                                ")"
                            : "Filter"
                        )
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "sm:absolute dpd-filter_tray last-child-mb-0",
                      class: { hidden: !this.deelnemerTrayOpened }
                    },
                    _vm._l(_vm.deelnemersOptions, function(deel, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass:
                            "px-6 sm:px-4 sm:whitespace-no-wrap flex items-start mb-2 md:mb-0"
                        },
                        [
                          _c("input", {
                            attrs: {
                              type: "checkbox",
                              name: "deelfilter" + index,
                              id: "deelfilter" + index
                            },
                            domProps: {
                              checked: _vm.checkIfSelected(
                                "deelnemers",
                                deel.deelnemerid
                              ),
                              value: deel.deelnemerid
                            },
                            on: {
                              click: function($event) {
                                return _vm.selectFilter(
                                  "deelnemers",
                                  deel.deelnemerid
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "deelfilter" + index } }),
                          _vm._v(" "),
                          _c("label", {
                            class: {
                              active: _vm.checkIfSelected(
                                "deelnemers",
                                deel.deelnemerid
                              )
                            },
                            attrs: { for: "deelfilter" + index },
                            domProps: { innerHTML: _vm._s(deel.title) }
                          })
                        ]
                      )
                    }),
                    0
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "fav-filter flex items-center sm:ml-3",
                  class: { active: _vm.formData.only_favourites },
                  on: {
                    click: function($event) {
                      return _vm.toggleShowFavourite()
                    }
                  }
                },
                [
                  _vm._v(
                    "Toon mijn favorieten (" + _vm._s(_vm.favouriteCount) + ")"
                  )
                ]
              )
            ])
          ])
        ]
      )
    ]),
    _vm._v(" "),
    _vm.noData
      ? _c("div", [_vm._m(0)])
      : _c("div", { staticClass: "bg-blueLight py-10 mt-10" }, [
          _vm.loading
            ? _c("div", { staticClass: "flex justify-center" }, [_vm._m(1)])
            : _c("div", { staticClass: "programmeCards flex flex-wrap" }, [
                _c("div", { staticClass: "container" }, [
                  _c(
                    "div",
                    { staticClass: "-mx-4 flex flex-wrap justify-start" },
                    _vm._l(_vm.data, function(d, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass:
                            "vue-card px-4 w-full sm:w-1/2 lg:w-1/3 xl:w-1/4 mb-4 sm:mb-8",
                          attrs: { "data-id": d.postid }
                        },
                        [
                          _c("card", {
                            attrs: { favourites: _vm.favourites, data: d },
                            on: {
                              setFavourite: function($event) {
                                return _vm.setFavourites(d.postid)
                              }
                            }
                          })
                        ],
                        1
                      )
                    }),
                    0
                  )
                ])
              ])
        ]),
    _vm._v(" "),
    _c("div", { staticClass: "flex justify-center pb-20 bg-blueLight" }, [
      !_vm.loadMoreClicked && _vm.navigation
        ? _c("div", { staticClass: "flex items-center" }, [
            _c(
              "button",
              {
                staticClass:
                  "button bg-blue cursor-pointer bg-blueDark text-white",
                on: {
                  click: function($event) {
                    return _vm.loadMore()
                  }
                }
              },
              [_vm._v("Toon meer")]
            )
          ])
        : _vm.loadMoreClicked && _vm.navigation
        ? _c("div", [_vm._m(2)])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "py-32 text-center" }, [
        _vm._v("Geen evenementen gevonden. Probeer het alstublieft opnieuw.")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "loader3" }, [
      _c("span"),
      _vm._v(" "),
      _c("span")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "loader3" }, [
      _c("span"),
      _vm._v(" "),
      _c("span")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/rohini/Workspace/Sites/wereldhavendagen/wp-content/themes/wereldhavendagen/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/rohini/Workspace/Sites/wereldhavendagen/wp-content/themes/wereldhavendagen/node_modules/vue-loader/lib?{}!./scripts/vue/Programmes.vue?vue&type=template&id=739261ea&
// module id = 30
// module chunks = 0